module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button toolbar-button",
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _c('h3', {
    staticClass: "md-title toolbar-title"
  }, [_vm._v(_vm._s(_vm.$store.state.pageTitle))]), _c('div', {
    staticClass: "sep",
    staticStyle: {
      "flex": "1"
    }
  }), _c('div', {
    staticClass: "search-container",
    on: {
      "click": function($event) {}
    }
  }, _vm._l((_vm.$route.meta.toolbars), function(toolbarName, index) {
    return ((typeof _vm.$route.meta.toolbars) != 'undefined') ? _c(_vm.toolbars[_vm.$route.meta.module][toolbarName], {
      key: index,
      tag: "component"
    }) : _vm._e()
  })), _c('div', {
    staticClass: "sep",
    staticStyle: {
      "flex": "1"
    }
  }), (_vm.$store.state.users.current) ? _c('div', {
    staticClass: "md-layout md-alignment-center-right user-menu toolbar-user-menu"
  }, [_c('md-menu', {
    attrs: {
      "md-size": "big",
      "md-align-trigger": "md-align-trigger"
    }
  }, [_c('md-button', {
    attrs: {
      "md-menu-trigger": "md-menu-trigger"
    }
  }, [_c('md-avatar', {
    staticClass: "md-avatar-icon md-small"
  }, [_c('md-icon', [_vm._v("person")])], 1), _c('span', [_vm._v(_vm._s(_vm.$store.state.users.current.login))])], 1), _c('md-menu-content', {
    attrs: {
      "md-theme": "white"
    }
  }, [_c('md-menu-item', {
    on: {
      "click": _vm.toUser
    }
  }, [_vm._v("Профиль")])], 1)], 1), _c('md-button', {
    staticClass: "md-icon-button md-dense",
    on: {
      "click": _vm.logOut
    }
  }, [_c('md-icon', [_vm._v("exit_to_app")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-193ba9a9","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 1048
// module chunks = 0